/**
 * Pastel palette for ngx-avatars (AvatarModule.forRoot({ colors })).
 * Global chrome (ring, shadow, initials color, family-tree override) lives in src/styles.css.
 */

export const KINNECT_AVATAR_PASTEL_COLORS: string[] = [
  '#EADAF1',
  '#FADAD1',
  '#D4E9F7',
  '#D2F9F1',
  '#F9F2D2',
  '#D2F9E2',
  '#D2D2F9',
  '#F9D2EB',
];
